import { memo, FC, useMemo } from 'react'
import { Text } from '@chakra-ui/react'
import { DescriptionItem } from 'components'

type KeyString = {
  [key: string]: string
}

type Props = {
  showType?: boolean
  type?: string
  label?: string
  value?: string
  formatValue?: (value?: string) => string
}

const MetadataText: FC<Props> = ({ formatValue, type, label, value, showType = false }) => {
  const typeText = useMemo(() => {
    const texts: KeyString = {
      STRING: 'Texto',
      TEXT: 'Texto largo',
      NUMBER: 'Número',
      DATE: 'Data',
      DATETIME: 'Data e hora',
      BOOLEAN: 'Sim ou Não',
    }

    return texts[type || 'STRING']
  }, [])

  if (!label) return <Text>{value}</Text>

  if (showType) {
    return <DescriptionItem label={label} value={typeText} />
  }

  return (
    <Text color="dark" as="span">
      {label}{' '}
      <Text as="span" color="primary">
        {formatValue ? formatValue(value) : value}
      </Text>
    </Text>
  )
}

export default memo(MetadataText)
